import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import FilterBar from './FilterBar';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const useStyles = makeStyles(() => ({
  image: {
    objectFit: 'cover',
    height: 70,
    width: 100,
  },
}));

const uri = '/service/v1/category/1';

const initialParams = {
  sort: 'az',
};

function Benefits() {
  const classes = useStyles();
  const [params, setParams] = React.useState(initialParams);

  function handleFilter(parms) {
    setParams({ ...initialParams, ...parms });
  }

  const Image = attr => (
    <img src={attr} alt="" className={classes.image} />
  );

  const Supplier = attr => (
    <Fragment>{attr.name}</Fragment>
  );

  const ExpirationDate = attr => (
    <Fragment>{attr.expiration_date}</Fragment>
  );

  const Tags = attr => (
    <Fragment>{ attr.join(' | ') }</Fragment>
  );

  const tableHeaders = [
    {
      name: 'main_company',
      label: 'Empresa',
    },
    {
      name: 'company',
      label: 'Proveedor',
      component: Supplier,
    },
    {
      name: 'img_main',
      label: 'Imagen',
      component: Image,
      width: 150,
    },
    {
      name: 'disclaimer',
      label: 'Disclaimer',
    },
    {
      name: 'tags',
      label: 'Tags',
      component: Tags,
      width: 280,
    },
    {
      name: 'terms_conditions',
      label: 'Fin de vigencia',
      component: ExpirationDate,
    },
  ];

  return (
    <>
      <Title variant="h5" component="h2">Descuentos</Title>
      <DataTable
        uri={uri}
        params={params}
        headers={tableHeaders}
        filters={<FilterBar onFilter={handleFilter} />}
      />
    </>
  );
}

Benefits.propTypes = propTypes;

export default Benefits;
